import { defineStore } from 'pinia'
import store from '@/store'
import type { RouteLocationNormalized } from 'vue-router'

interface AppState {
    // 当前路由
    currentRoute: RouteLocationNormalized | null
    // 主题模式
    themeMode: 'dark' | 'light'
}

export const appStore = defineStore({
    id: 'app',
    state: (): AppState => ({
        currentRoute: null,
        themeMode: localStorage.themeMode || 'light',
    }),
    getters: {
        getThemeMode(): AppState['themeMode'] {
            return this.themeMode
        },
        getCurrentRoute(): any {
            return this.currentRoute
        },
    },
    actions: {
        changeThemeMode(mode?: 'light' | 'dark') {
            this.themeMode = mode || this.themeMode == 'dark' ? 'light' : 'dark'
            localStorage.themeMode = this.themeMode
        },
        setCurrentRoute(route: RouteLocationNormalized) {
            this.currentRoute = route
        },
    },
})

export default function useAppStore() {
    return appStore(store)
}
